import React, { useContext, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import AuthContext from 'common/auth';
import useApi from 'common/useApi';
import useFormApiErrors from 'common/useFormApiErrors';

const Otp = ({ close }: { close(): void }) => {
  const { refetch } = useContext(AuthContext)!;
  const { data } = useApi('get', '/api/me/start-otp');

  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit, register, formState: { isSubmitting, isValid, isDirty }, setError, setValue } = formMethods;
  const { error, isLoading, isFetching, isError, isSuccess, mutate } = useApi('post', '/api/me/finish-otp');

  useFormApiErrors(isError, error, setError, isSuccess, 'Token verified');

  const onSubmit = ({ token }: Record<string, string>) => {
    mutate({ token });
  };

  useEffect(() => {
    if(isSuccess) {
      setValue('token', null);
      refetch();
      close();
    }
  }, [isSuccess]);

  const formDisabled = isSubmitting || isLoading || isFetching || (!isValid && isDirty);

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ul>
          <li>Install Google Authenticator on your smartphone. (Apple, Android)</li>
          <li>Open Google Authenticator, click &quot;Add an account&quot; / &quot;Scan QR code&quot;.</li>
          <li>Scan the QR code below (and optionally backup the generated secret).</li>
          <li>Enter the generated one-time password into this form.</li>
        </ul>
        {data && (
          <img
            className='otp-qr'
            alt='OTP setup QR code'
            src={`data:image/svg+xml;utf8,${encodeURIComponent(data)}`}
          />
        )}
        <label>
          <p>Enter the one-time password generated by your OTP app</p>
          <input
            type='text'
            placeholder='######'
            {...register('token', {
              minLength: {
                message: 'Token must be exactly 6 characters long',
                value: 6,
              },
              maxLength: {
                message: 'Token must be exactly 6 characters long',
                value: 6,
              },
              required: 'Token can\'t be blank',
            })}
          />
        </label>

        <button className='secondary big' onClick={() => close()}>Cancel</button>
        <button type='submit' className='primary big' disabled={formDisabled}>Enable OTP</button>
      </form>
    </FormProvider>
  );
};

export default Otp;